// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RegisterForm from './RegisterForm';
import Admin from './admin/Admin';
import Stats from './admin/stats';
import './App.css';

function App() {
  return (
    <Router>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        height: '100vh',
        padding: '20px'
      }}>
        <div className="App">
          <Routes>
            <Route path="/" element={<RegisterForm />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/stats" element={<Stats />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
